


import { Component, Vue } from 'vue-property-decorator';

import DropUp, {
  DropUpColorHover,
} from '@/shared/components/DropUp.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    DropUp,
    Icon,
    ExpansionPanel,
  },
})
export default class PartialDropUp extends Vue {
  private iconEnum = IconEnum;
  private dropUpColorHover = DropUpColorHover;
  private data = [
    {
      id: 1,
      name: 'Exportar lista',
    },
    {
      id: 2,
      name: 'Email masivo',
    },
  ];

  private elementSelected(element: any) {
    alert(element.name);
  }
}
